<ul class="nav nav-tabs tab-container" id="tabContainer">
  <li class="nav-item active cursor" *ngFor="let tab of tabs" (click)="selectTab(tab)" [class.active]="tab.active">
    <div class="tab-wrapper">
      <div class="highlighter"></div>
    <a class="nav-link tab-link" [class.text-color]="tab.active" [class.text-flipcolor]="!tab.active" tooltip [tooltipContent]="tab.title">{{tab.title}}</a>
    <div class="height-corrector"></div>
  </div>
  </li>
  <!-- dynamic tabs -->
  <div class="dynamicTabsContainer">
    <li class="nav-item cursor" *ngFor="let tab of dynamicTabs" (click)="selectTab(tab)" [class.active]="tab.active">
      <div class="tab-wrapper">
        <div class="highlighter"></div>
        <div [class.errorDiv]="tab.hasApiError">
      <img *ngIf="tab.hasApiError" class="warning-img" src="../../../assets/icons/Warning.svg"
        title="{{tab.apiErrorMessage}}" />
      <a class="nav-link tab-link" [class.text-color]="tab.active" [class.text-flipcolor]="!tab.active"
        [class.warning-tab]="tab.hasApiError" tooltip [tooltipContent]="tab.tooltip">{{tab.title}}
        <span class="tab-close" [class.text-color]="tab.active" [class.text-flipcolor]="!tab.active"
          *ngIf="tab.isCloseable" (click)="handleTabClose(tab)">
          <img *ngIf="tab.active" src="../../../assets/icons/Close.svg" alt="close" />
          <img *ngIf="!tab.active" src="../../../assets/icons/Close-White.svg" alt="close" /></span>
      </a>
    </div>
      <div class="height-corrector"></div>
        </div>
    </li>
  </div>
</ul>
<ng-content></ng-content>
<ng-template dynamic-tab #container></ng-template>
